export default "__VITE_ASSET__DjRFwZzA__"